import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/TwoColumnWithPrimaryBackground.js";
import SliderCard from "components/cards/ThreeColSlider.js";
import AllProducts from "components/cards/TabCardGrid.js";
import Testimonial from "components/testimonials/TwoColumnWithImageAndProfilePictureReview.js";
import FAQ from "components/faqs/SingleCol.js";
import Footer from "components/footers/FiveColumnDark.js";

export default () => (
  <AnimationRevealPage>
    <Hero />
    <SliderCard />
    <AllProducts />
    {/* <Testimonial textOnLeft={true}/> */}
    {/* <FAQ /> */}
    <Footer />
  </AnimationRevealPage>
);
